import { isPresent } from '@ember/utils';
import {
  validateLength,
  validateNumber,
  validatePresence
} from 'ember-changeset-validations/validators';
import validateOnCheck from 'volta/validators/on-check';

export default {
  skuIds: [validatePresence(true), validateLength({ min: 1 })],
  acqCode: [],
  leadTime: validateNumber({ gt: 0, allowBlank: true, integer: true }),
  internalLeadTime: [
    validateNumber({ positive: true, allowBlank: true, integer: true }),
    validateOnCheck({
      checkKeys: ['leadTime'],
      checkCondition: (internalLeadTime?: number, leadTime?: number) => {
        return internalLeadTime == null || (isPresent(leadTime) && internalLeadTime <= leadTime!);
      },
      i18nKey: 'internalLeadTime',
      i18nType: 'lessThan',
      i18nContext: (_ilt: number, lt: number = 0) => ({ lt })
    })
  ],
  orderMultiple: validateNumber({ positive: true, allowBlank: true }),
  moq: validateNumber({ positive: true, allowBlank: true }),
  maxPOQty: validateNumber({ positive: true, allowBlank: true }),
  deliveryWorkshopId: [],
  workshopId: [],
  supplierId: []
};
